// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AircraftSection.css */
.highlight {
  animation: highlightAnimation 2s ease-out;
}

@keyframes highlightAnimation {
  from {
    background-color: #ffffcc; /* Light yellow */
  }
  to {
    background-color: transparent;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/profile/aircraft/AircraftSection.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,yBAAyB,EAAE,iBAAiB;EAC9C;EACA;IACE,6BAA6B;EAC/B;AACF","sourcesContent":["/* AircraftSection.css */\n.highlight {\n  animation: highlightAnimation 2s ease-out;\n}\n\n@keyframes highlightAnimation {\n  from {\n    background-color: #ffffcc; /* Light yellow */\n  }\n  to {\n    background-color: transparent;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
